import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KingClubRoutingModule } from './king-club-routing.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { SharedModule } from '../shared/shared.module';
import { ClubProductCashbackComponent } from './club-product-cashback/club-product-cashback.component';
import { AccountSwitchDialogComponent } from './account-switch-dialog/account-switch-dialog.component';


@NgModule({
  declarations: [
    LandingPageComponent,
    ClubProductCashbackComponent,
    AccountSwitchDialogComponent
  ],
  imports: [
    CommonModule,
    KingClubRoutingModule,
    SharedModule
  ],
  exports:[
    ClubProductCashbackComponent
  ]
})
export class KingClubModule { }
